import React, { useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { COLORS_ADMIN_PAGE } from '../../conf/constants';
import { cleanFilename, getFileTypeLabel } from '../utils/fileUtils';
import { OfficeDocumentViewerProps } from '../types/contractor.types';

const OfficeDocumentViewer: React.FC<OfficeDocumentViewerProps> = ({ filename, fileType }) => {
  const [viewerError, setViewerError] = useState(false);
  
  const getViewerUrl = () => {
    const encodedUrl = encodeURIComponent(cleanFilename(filename));
    return `https://docs.google.com/viewer?url=${encodedUrl}&embedded=true`;
  };

  if (viewerError) {
    return (
      <Box sx={{ textAlign: 'center', p: 3 }}>
        <Typography variant="h6" sx={{ mb: 2, color: '#ff9800' }}>
          Unable to preview {getFileTypeLabel(fileType)}
        </Typography>
        <Typography variant="body2" sx={{ mb: 3, color: '#666' }}>
          This document cannot be previewed in the browser.
        </Typography>
        <Button 
          variant="contained"
          href={cleanFilename(filename)}
          target="_blank"
          rel="noopener noreferrer"
          sx={{ bgcolor: COLORS_ADMIN_PAGE.PRIMARY }}
        >
          Download File
        </Button>
      </Box>
    );
  }

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <Typography variant="body2" sx={{ mb: 1, color: '#2196f3', textAlign: 'center' }}>
        Viewing {getFileTypeLabel(fileType)} with Google Docs Viewer
      </Typography>
      <iframe
        src={getViewerUrl()}
        style={{ 
          width: '100%', 
          height: '100%', 
          border: 'none',
          borderRadius: '4px'
        }}
        title={`${getFileTypeLabel(fileType)} Viewer`}
        onError={() => setViewerError(true)}
      />
    </Box>
  );
};

export default OfficeDocumentViewer;